// src/beta/store/showcase.ts
import { create } from 'zustand';
import type { Axis } from '@/beta/types/showcase';

interface ShowcaseState {
  currentVehicleId: string | null;
  axis: Axis;
  isAttract: boolean;

  setVehicleId: (id: string | null) => void;
  setAxis: (axis: Axis) => void;
  setIsAttract: (v: boolean) => void;
  reset: () => void;
}

const DEFAULTS = {
  currentVehicleId: null as string | null,
  axis: 'phase' as Axis,
  isAttract: false,
};

/** UI state for the Focus screen.
 *  - `currentVehicleId`: which vehicle is being viewed
 *  - `axis`: which of the 5 axes is active in the strip
 *  - `isAttract`: true after idle timeout — Phase G animates off this
 *
 *  Switching vehicles resets axis to 'phase' and clears attract — fresh stage
 *  on every transition. */
export const useShowcaseStore = create<ShowcaseState>((set, get) => ({
  ...DEFAULTS,

  setVehicleId: (id) => {
    if (get().currentVehicleId === id) return;
    set({ currentVehicleId: id, axis: 'phase', isAttract: false });
  },

  setAxis: (axis) => set({ axis }),

  setIsAttract: (isAttract) => set({ isAttract }),

  reset: () => set({ ...DEFAULTS }),
}));
